import { MessageBox, Loading } from 'element-ui'
import { getToken, getUserToken } from '@/utils/cookies'
import constant from '@/api/constant'

const utils = {
}
/** 消息提示方法 */
utils.msgAlert = function (type, msg) {
  MessageBox.alert(msg, '提示', {
    confirmButtonText: '确定',
    type: type,
    callback: action => {
    }
  })
}
/** 遮罩 */
utils.Loading = function (tipsMsg) {
  const loading = Loading.service({
    lock: true,
    text: tipsMsg,
    background: 'rgba(0, 0, 0, 0.7)'
  })
  return loading
}

/** 不为空的判断 */
utils.isNotEmpty = function (param) {
  var falg = false
  if (param !== '' && param !== undefined && param !== null) {
    falg = true
  }
  return falg
}

/** 拼接axios请求参数配置 */
utils.getAxiosOption = function (method, url, params, data) {
  var option = {
    method: method,
    url: url,
    params: params,
    data: data
  }
  return option
}

/** 手机号替换中间四位**** */
utils.phoneReplace = function (val) {
  if (val !== '' && val !== undefined && val !== null) {
    let reg = /^(.{3}).*(.{4})$/
    return val.replace(reg, '$1****$2')
  }
}

/** 生成UUID */
utils.uuid = function () {
  var s = []
  var hexDigits = getUserToken() + getToken()
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  var uuid = s.join('')
  return uuid
}

/** 获取数组中的目标数据，数组格式 [{id: 1},{id: 2}] */
utils.getOptionItemInArray = function (arrayData, validField, validContent) {
  let targetObj = {}
  targetObj = arrayData.find((item) => {
    return item[validField] === validContent
  })
  return targetObj
}

/** 获取数组中目标数据索引 */
utils.getOptionIndexInArray = function (arrayData, validField, validContent) {
  let changeIndex = -1
  changeIndex = arrayData.findIndex((item, index) => {
    return item[validField] === validContent
  })
  return changeIndex
}

/** 移除数组中的目标数据 */
utils.reduceOptionItemInArray = function (arrayData, validField, validContent) {
  if (arrayData.length > 0) {
    for (let i = 0; i < arrayData.length; i++) {
      if (arrayData[i][validField] === validContent) {
        arrayData.splice(i, 1)
      }
    }
  }
}
/** 移除数组中元素 */
utils.reduceItemInArray = function (arrayData, validContent) {
  if (arrayData.length > 0) {
    for (let itemIndex in arrayData) {
      if (arrayData[itemIndex] === validContent) {
        arrayData.splice(itemIndex, 1)
      }
    }
  }
}

/** 生成随机数方法 */
utils.getRandomNum = (minNum, maxNum) => {
  let max = 800
  let min = 0
  if (maxNum) max = maxNum
  if (minNum) min = minNum
  return parseInt(Math.random() * (max - min + 1) + min, 10)
}

utils.getToReadUrlByCategory = (category, params) => {
  console.log('category',category)
  let toReadPath = constant.read_web_url
  if ((constant.pl_kec == category) || (constant.pl_sp == category)) {
    toReadPath += '/read_cl?resourceId=' + params.resourceId + '&type=' + category
  } else if ((constant.pl_sj == category)) {
    toReadPath += '/pcExam?resourceId=' + params.resourceId + '&type=' + category
    delete params["title"]
    params['masterId'] = 0, params['doPaperDate'] = 'doAgain', params['submitId'] = ''
  } else if ((constant.pl_al == category) || (constant.pl_ts == category) ||  (constant.pl_gf== category) ||  (constant.pl_wz== category) ||  (constant.pl_lxcbw== category)) {
    toReadPath += '/service?resourceId=' + params.resourceId + '&type=' + category
  }else if ((constant.pl_zlj == category) ) {
    toReadPath += '/pcCatalog?resourceId=' + params.resourceId + '&type=' + category
  } else if ((constant.pl_xt == category)) {
    toReadPath += '/pcExercises?resourceId=' + params.resourceId + '&type=' + category
    delete params["title"]
    params['masterId'] = 0, params['doPaperDate'] = 'doAgain', params['submitId'] = ''
  } else {
    toReadPath = ''
  }
  delete params["resourceId"]
  if (utils.isNotEmpty(toReadPath)) {
    for (let paramIndex in params) {
      toReadPath += '&' + paramIndex + '=' + params[paramIndex]
    }
  }
  return toReadPath
}


utils.IEVersion = ()=>{
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
  var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
  var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
  var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
   
  if(isIE) {
      var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
      reIE.test(userAgent);
      var fIEVersion = parseFloat(RegExp["$1"]);
      if(fIEVersion == 7) {
          return 7;
      } else if(fIEVersion == 8) {
          return 8;
      } else if(fIEVersion == 9) {
          return 9;
      } else if(fIEVersion == 10) {
          return 10;
      } else {
          return 6;//IE版本<=7
      }   
  } else if(isEdge) {
      return 'edge';//edge
  } else if(isIE11) {
      return 11; //IE11  
  }else{
      return -1;//不是ie浏览器
  }
}



export default utils



// WEBPACK FOOTER //
// ./src/utils/utils.js